import styled from 'styled-components';

const CommodityRulesStyled = styled.div`
  .init-tabs-wrap-style {
    margin-left: 24px;
    .init-tab-style-one {
      border-left: 1px solid #818286;
      border-top-left-radius: 3px;
    }
    .init-tab-style-four {
      border-right: 1px solid #818286;
      border-top-right-radius: 3px;
    }
    .init-tab-style {
      color: #666464;
      font-size: 16px;
      background-color: #ffffff;
      border-top: 1px solid #818286;
    }
    .Mui-selected {
      color: #ffffff;
      background-color: ${(props) => props.theme.palette.primary.main};
      border: 0;
    }
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .checkbox-radio-disabled-button-color {
    background-color: #666464 !important;
    color: #ffffff !important;
  }
  .MuiButton-contained.Mui-disabled {
    background-color: #212121;
  }
  .init-tabs-wrap > .MuiBox-root {
    padding: 0;
  }
  .level-content {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 910px;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid #dddddd;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    align-items: center;
    div {
      display: flex;
      flex-direction: row;
    }
    .coupon,
    .noCoupon {
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
    .coupon {
      fill: #1565c0;
    }
    .noCoupon {
      fill: #c9c9c9;
    }
    .coupon-num {
      width: 100%;
      color: #1565c0;
    }
    .noCoupon-num {
      width: 100%;
      color: #c9c9c9;
    }

    .MuiOutlinedInput-root {
      height: 24px !important;
      margin-right: 0 !important;
      margin: auto;
    }
    .MuiInputBase-input {
      width: 60px;
      text-align: center !important;
    }
    .basic-name {
      background: #ffffff;
      margin-right: 0 !important;
      margin: auto;
    }
  }
  .table-container .MuiFormControl-root {
    justify-content: center;
  }
  .coupons {
    background: #1565c0;
    margin-right: 4px;
  }
  .noCoupons {
    background: #666464;
    margin-right: 4px;
  }
  .coupon-settings {
    width: 40px !important;
    height: 28px;
    border-radius: 4px;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    margin: auto;
    margin-left: ${(props) => props.theme.spacing(6 / 8)};
  }
  .coupon {
    fill: #1565c0;
  }
  .noCoupon {
    fill: #c9c9c9;
    margin-right: 4px;
  }
  .coupon-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    .coupon,
    .noCoupon {
      width: 18px;
      height: 18px;
    }
  }
  .add-btn {
    margin-left: 24px;
    /* margin-bottom: ${(props) => props.theme.spacing(1)}; */
  }
  .checkbox-wrap {
    margin-top: ${(props) => props.theme.spacing(5)};
  }
  .select-wrap {
    display: flex;
    flex-direction: row;
    margin-bottom: ${(props) => props.theme.spacing(4)};
  }
  .select-wrap,
  .checkbox-wrap {
    color: #000000;
    font-size: 14px;
  }
  .commodity-title-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 910px;
    height: 48px;
    background: #f6f6f6;
    border-radius: 4px;
    font-size: 16px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    line-height: 48px;
    span:last-of-type {
      color: #1565c0;
    }
  }
  .MuiInputBase-input {
    width: 60px;
    text-align: right !important;
  }
`;

export default CommodityRulesStyled;
